export const THIS_FIELD_CANNOT_BE_EMPTY = 'This field cannot be empty';
